import axios from 'axios';
export default async (context, locale) => {
  return axios.get('https://qubino.salesqueze.com/api/v3/system/translation/export/i18next?serviceKey=form--configurator&x-client-key=qubino&language=en-US').then((res) => {
    return res.data
  })
}
